import client from './client';

const Properties = {
  getProperties(anketId) {
    return client.get(`/ankets/${anketId}/properties`);
  },
  getProperty(anketId, propertyId) {
    return client.get(`/ankets/${anketId}/properties/${propertyId}`);
  },
};

export default Properties;
